import React from "react";
import Accordion from "../components/Accordion/Accordion";
import Footer from "../components/Footer/Footer";

const faq = () => {
  const accordionData = [
    {
      title: "What is SoundOff?",
      content: `SoundOff is a 24/7 music contest platform. We partner with music influencers (think bloggers, playlisters, & artists too) to create contests with different genres & themes. Every contest is 3 rounds, 72 Hours each round, and 8 artists.`,
    },
    {
      title: "Once I submit, how long till I'm in the contest?",
      content: `Once you submit to a contest channel you''ll be placed in line. Since every contest is 8 artists, when you're one of the next 8 in line, you'll be placed in the next contest! For those that don't want to wait; head to the homepage, and click the "Skip The Line" button for more info!`,
    },
    {
      title: "What do winners get?",
      content: `Before you submit to a contest channel, you'll see a description of the contest channel that will tell you the prize that the music influencer is giving to the winner of the contest; for any additional questions, check-in with SoundOff and/or the contest host to make sure you know your contest prize!`,
    },
  ];
  return (
    <>
      <div className="justify-center text-center items-center md:p-12 pt-12 h-full">
        <div className="flex justify-center text-center items-center">
          <h1 class="text-white font-bold text-3xl">FAQ</h1>
        </div>

        <div className="accordion">
          {accordionData.map(({ title, content }) => (
            <Accordion title={title} content={content} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default faq;
